import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActividadCalendario } from '@app/shared';
import { EndpointService } from '@app/core';

export interface Estructura {
  label: string;
  alias: string;
  orden: number;
  tipo: string;
}

export interface CalendarioDinamico {
  id?: number;
  nombre?: string;
  descripcion?: string;
  estructura?: Estructura[];
}

export interface InfoCalendarioDinamico {
  id: number;
  nombre: string;
  fecha_asignacion: Date;
  id_tramite: number;
  categoria: number;
  proceso: number;
  microproceso?: any;
  secundaria?: any;
  rechazable: boolean;
  consecutivo: number;
  sede: string;
  tramite: string;
  actividad: string;
  radicado_solicitud: string;
}


@Injectable()
export class CalendarService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta la información necesaria para generar el calendario de actividades.
   *
   * @param {number} idUsuario
   * @returns {Observable<ActividadCalendario[]>}
   * @memberof CalendarService
   */
  getDataCalendar(idUsuario: number): Promise<ActividadCalendario[]> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().get<ActividadCalendario[]>(this.api.get('activityCalendar', [idUsuario])).subscribe(
        data => {
          resolve(data);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(`No se pudó consultar la información del calendario`, 'Operación fallida');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Rechaza la tarea
   *
   * @param {number} idTarea
   * @param {string} motivo
   * @returns {Observable<boolean>}
   * @memberof CalendarService
   */
  rejectTask(idTarea: number, motivo: string): Observable<boolean> {
    const formData = {
      tarea_id: idTarea,
      descripcion: motivo
    };
    return new Observable(obs => {
      this.http.skipErrorHandler().post(this.api.get('rejectTask'), {
        tarea_id: idTarea,
        descripcion: motivo
      }).subscribe(
        data => {
          obs.next(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(`La tarea no se pudo rechazar`, 'Operación fallida');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   *Obtiene los calendarios disponibles 
   *
   * @return {*}  {Observable<CalendarioDinamico[]>}
   * @memberof CalendarService
   */
  getAvailableCalendar(): Observable<CalendarioDinamico[]>{
    return new Observable(obs=>{
      this.http.get<CalendarioDinamico[]>(this.api.get('dynamicCalendar')).subscribe(res=>{
        if(res && res.length){
          obs.next(res);
        }
      })
    })
  }

  /**
   *Obtiene la información del calendario dinámico seleccionado
   *
   * @param {number} id_calendario
   * @return {*}  {Observable<InfoCalendarioDinamico[]>}
   * @memberof CalendarService
   */
  getCalendarData(id_calendario: number): Observable<InfoCalendarioDinamico[]>{
    const body = {
      id_calendario: id_calendario
    }
    return new Observable(obs=>{
      this.http.post<InfoCalendarioDinamico[]>(this.api.get('dynamicCalendar'), body).subscribe(res=>{
        if(res){
          obs.next(res);
        }
      })
    })
  }

  /**
   *Servicio para descargar documento
   *
   * @param {number} idDocumento
   * @return {*}  {Observable<any>}
   * @memberof CalendarService
   */
   dowloadFile(idDocumento: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('docsInstance', [idDocumento]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.warning(err.error['message'], 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/shared/calendar.service.ts